import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { CONTACT_SECTION_ID, PAGE_NAV_ITEMS } from "./Header.config";
import type { HeaderNavSharedProps } from "./HeaderNav.types";
import {
  desktopNavWrapperSx,
  getNavLinkActiveSx,
  navLinkSx,
} from "./Header.sx";

export function DesktopNav({
  isDarkMode,
  activeSection,
  isPageNavItemActive,
  onPageClick,
  onContactClick,
}: HeaderNavSharedProps) {
  return (
    <Stack
      display={{ xs: "none", sm: "flex" }}
      direction="row"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100%"
      sx={desktopNavWrapperSx}
    >
      {PAGE_NAV_ITEMS.map((item) => (
        <Box
          key={item.path}
          component="button"
          onClick={() => onPageClick(item.path)}
          sx={[navLinkSx, getNavLinkActiveSx(isPageNavItemActive(item.path), isDarkMode)]}
        >
          {item.label}
        </Box>
      ))}
      <Box
        component="button"
        onClick={onContactClick}
        sx={[navLinkSx, getNavLinkActiveSx(activeSection === CONTACT_SECTION_ID, isDarkMode)]}
      >
        Contact
      </Box>
    </Stack>
  );
}
